export class GridUtil {
    public static filterGrid(row: any, textFilter: string): boolean {
        const filter = new RegExp(textFilter, "i");
        for (const key in row) {
            if (filter.test(String(row[key]))) {
                return true;
            }
        }
        return false;
    }

    /**
     * Propogates the row click event on the specified row index
     *
     * @param {HTMLTableElement} table
     * @param {number} rowIndex
     */
    public static propagateSelection(table: HTMLTableElement, rowIndex: number): void {
        // wishing bootstrap-vue wouldn't internally prevent the checkbox click from bubbling to the row
        table
            .getElementsByTagName("tbody")[0]
            .getElementsByTagName("tr")
            [rowIndex].click();
    }

    public static localizeColumnLabels(columns: ILocalizationKey[], getContentItem: (key: string) => string): any[] {
        return columns.map((column: any) => {
            if (typeof column === "object" && column.localizationKey) {
                return {
                    ...column,
                    label: getContentItem(column.localizationKey)
                };
            }
            return column;
        });
    }
}

export interface ILocalizationKey {
    localizationKey: string;
}
